import { Base } from '@studiometa/js-toolkit';
import SecretProperty from './SecretProperty.js';

/**
 * StickyBar
 */
export default class ProductStickyAddToCart extends Base {
  static config = {
    name: 'ProductStickyAddToCart',
    components: {
      SecretProperty,
    },
    options: {
      offset: {
        type: Number,
        default: 50,
      },
    },
  };

  /**
   * Set variables
   */
  mounted() {
    this.mainAddToCart = document.querySelector('#main-add-to-cart');
    this.isVisible = false;
  }

  /**
   * Calc add to cart position when window is resized
   */
  resized() {
    this.position = this.addToCartPosition;
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @returns {void}
   */
  scrolled() {
    // if buybox is not sticky, put this value in mounted
    this.position = this.addToCartPosition;

    if (this.position < this.$options.offset && !this.isVisible) {
      this.$el.classList.remove('translate-y-full');
      this.isVisible = true;
      return;
    }

    if (this.isVisible && this.position >= this.$options.offset) {
      this.isVisible = false;
      this.$el.classList.add('translate-y-full');
    }
  }

  /**
   * Get Main Add To Cart position
   * @returns {number}
   */
  get addToCartPosition() {
    return this.mainAddToCart.getBoundingClientRect().top;
  }
}
